import { render, staticRenderFns } from "./CBProposalStockRecords.vue?vue&type=template&id=173d99d2"
import script from "./CBProposalStockRecords.vue?vue&type=script&lang=js"
export * from "./CBProposalStockRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports